module.exports = __webpack_public_path__ + "static/media/dtr.70153428.svg";